module.exports = __webpack_public_path__ + "img/screens-isanon.79a46835.png";